import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import * as S from './PrevTrackButton.styles';
import * as T from './PrevTrackButton.types';
import * as SL from 'modules/Player/selectors';
import * as A from 'modules/Player/actions';

export class PrevTrackButton extends PureComponent<T.IPrevTrackButtonProps> {
  getIsDisabled = () => {
    const { showApiRequestErrorMessage, showId, prevAvailableTrackIdInPlaylist } = this.props;

    return (
      showApiRequestErrorMessage.length > 0 || !Boolean(showId) || !prevAvailableTrackIdInPlaylist
    );
  };

  onSelectPrevTrack = () => {
    const { prevAvailableTrackIdInPlaylist, dispatchSetCurrentlyPlayingTrackId } = this.props;

    if (this.getIsDisabled()) {
      return;
    }

    dispatchSetCurrentlyPlayingTrackId({
      id: prevAvailableTrackIdInPlaylist,
    });
  };

  render() {
    const { width = 16, height = 16 } = this.props;

    return (
      <S.PrevTrackButtonWrapper
        data-testid="PrevTrackButton"
        className={`noselect ${this.getIsDisabled() ? 'isDisabled' : ''}`}
        onClick={this.onSelectPrevTrack}
      >
        <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 12 12">
          <path d="M193.987,997l7,3.985v-7.975Z" transform="translate(-191 -991)" />
          <path d="M193,1001v-8" transform="translate(-191 -991)" />
        </svg>
      </S.PrevTrackButtonWrapper>
    );
  }
}

const mapStateToProps = (state: any) => ({
  prevAvailableTrackIdInPlaylist: SL.getPrevAvailableTrackIdInPlaylist(state),
  showApiRequestErrorMessage: SL.getShowApiRequestErrorMessage(state),
  showId: SL.getShowId(state),
});

const mapDispatchToProps = {
  dispatchSetCurrentlyPlayingTrackId: A.setCurrentlyPlayingTrackId,
};

export default connect(mapStateToProps, mapDispatchToProps)(PrevTrackButton);
